<template>
	<div>
		<div class="form-row mb-3">
			<div class="col-lg-6">
                <label for="">Prioridad *</label>
                <select v-model="CheckArranque.Prioridad" class="form-control" :disabled="RolUsuario=='Monitoreo' || CheckArranque.IdCheckArranque>0">
					<option value="">- Prioridad -</option>
					<option value="1">Alta</option>
					<option value="2">Media</option>
					<option value="3">Baja</option>
				</select>
                <Cvalidation v-if="this.errorvalidacion.Prioridad" :Mensaje="errorvalidacion.Prioridad[0]"></Cvalidation>
            </div>
			<div class="col-lg-6 mb-3">
                <label for="">Tipo *</label>
                <select v-model="CheckArranque.Tipo" class="form-control" :disabled="RolUsuario=='Monitoreo' || CheckArranque.IdCheckArranque>0">
					<option value="">- Tipo -</option>
					<option value="1">Instalación Mecánica</option>
					<option value="2">Instalación Eléctrica</option>
					<option value="3">Incorrecta Reparación</option>
					<option value="4">Condición Peligrosa</option>
					<option value="5">Incorrecto Mantenimiento</option>
				</select>
                <Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="errorvalidacion.Tipo[0]"></Cvalidation>
            </div>
			<div class="col-lg-12 mb-3">
                <label for="">Oportunidades Encontradas</label>
                <textarea :disabled="RolUsuario=='Monitoreo'" class="form-control" name="" id="" cols="30" rows="5" v-model="CheckArranque.Observaciones"></textarea>
                <Cvalidation v-if="this.errorvalidacion.Observaciones" :Mensaje="errorvalidacion.Observaciones[0]"></Cvalidation>
            </div>
			<div v-if="CheckArranque.IdCheckArranque>0" class="col-lg-6 mb-3">
				<label for="">Fecha de Solución</label>
				<v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="CheckArranque.FechaSolucion" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
					:locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-6 mb-3">
				<label>Documento</label>
				<div class="custom-file-input-image">
					<input :disabled="CheckArranque.IdCheckArranque>0" @change="SubirArchivo()" type="file" accept="application/pdf" ref="filecheckarranque" class="custom-file-input" id="validatedCustomFile" required>
					<input :disabled="CheckArranque.IdCheckArranque>0" type="text" v-model="Archivo" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
			<div class="col-lg-12" v-if="CheckArranque.IdCheckArranque>0">
                <label for="">Soluciones</label>
                <textarea :disabled="RolUsuario=='Monitoreo'" class="form-control" name="" id="" cols="30" rows="5" v-model="CheckArranque.Soluciones"></textarea>
                <Cvalidation v-if="this.errorvalidacion.Soluciones" :Mensaje="errorvalidacion.Soluciones[0]"></Cvalidation>
            </div>
		</div>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue';
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	props:["oEquipo","poBtnSave","RolUsuario","pCliente","pClienteS"],
	data() {
		return {
			Modal:true,
            FormName:'checkarranque',
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			CheckArranque:{
				IdCheckArranque:0,
				IdEquipo:0,
				Tipo:'',
				Observaciones:'',
				IdCliente:0,
				IdClienteS:0,
				Archivo:'',
				FechaSolucion:'',
				Prioridad:'',
				Soluciones:''
			},
			Archivo:'',
			errorvalidacion:[]
		}
	},
	components:{Cbtnsave, Cvalidation},
	methods: {
		async Guardar(){
            // this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			let image=this.$refs.filecheckarranque.files[0];
			let FechaSolucion='';
			if (this.CheckArranque.FechaSolucion !='' && this.CheckArranque.FechaSolucion!=undefined) {
				let day=this.CheckArranque.FechaSolucion.getDate();
                let month=this.CheckArranque.FechaSolucion.getMonth()+1;
                let year=this.CheckArranque.FechaSolucion.getFullYear();
                FechaSolucion=year+'-'+month+'-'+day;
			}
            let formData=new FormData();
            formData.set('IdCheckArranque',this.CheckArranque.IdCheckArranque);
            formData.set('Observaciones',this.CheckArranque.Observaciones);
			formData.set('Tipo',this.CheckArranque.Tipo);
			formData.set('IdCliente',this.pCliente.IdCliente);
			formData.set('IdClienteS',this.pClienteS.IdClienteS);
            formData.set('IdEquipo',this.oEquipo);
			formData.set('Prioridad',this.CheckArranque.Prioridad);
			formData.set('Soluciones',this.CheckArranque.Soluciones);
			formData.set('FechaSolucion',FechaSolucion);
			formData.set('NombreArchivo',this.CheckArranque.Archivo);
			formData.set('NombreArchivoFile',image);
            await this.$http.post('checkarranque/post',formData,{
                
            }).then((res)=>{
                this.poBtnSave.disableBtn=false;
                // this.poBtnSave.toast=1;
                this.$toast.success("Información guardada");
                $('#checkarranque').modal('hide');
                this.bus.$emit('Listar');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                // this.poBtnSave.toast=2;
                this.$toast.info("Complete los campos por favor");
            })
        },
		getOne(){
            this.$http.get('checkarranque/recovery',
            {
                params:{IdCheckArranque:this.CheckArranque.IdCheckArranque}
            }).then((res)=>{
                this.CheckArranque.IdCheckArranque=res.data.data.checkarranque.IdCheckArranque;
                this.CheckArranque.IdEquipo=res.data.data.checkarranque.IdEquipo;
                this.CheckArranque.Tipo=res.data.data.checkarranque.Tipo;
				this.CheckArranque.Observaciones=res.data.data.checkarranque.Observaciones;
				this.CheckArranque.IdCliente=res.data.data.checkarranque.IdCliente;
				this.CheckArranque.IdClienteS=res.data.data.checkarranque.IdClienteS;
				this.CheckArranque.Prioridad=res.data.data.checkarranque.Prioridad;
				this.CheckArranque.Soluciones=res.data.data.checkarranque.Soluciones;
				if (res.data.data.checkarranque.FechaSolucion!=null) {
					let formatedDate = res.data.data.checkarranque.FechaSolucion.replace(/-/g, "\/");
                	this.CheckArranque.FechaSolucion=new Date(formatedDate);	
				}
				this.Archivo=res.data.data.checkarranque.Archivo;
				this.CheckArranque.Archivo=res.data.data.checkarranque.Archivo;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		Limpiar(){
			this.CheckArranque={
				IdCheckArranque:0,
				IdEquipo:0,
				Tipo:'',
				Observaciones:'',
				IdCliente:0,
				IdClienteS:0,
				Archivo:'',
				FechaSolucion:'',
				Prioridad:'',
				Soluciones:''
			};
			this.Archivo='Elegir Archivo (1MB)';
        },
		SubirArchivo(){
			const image = this.$refs.filecheckarranque.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                this.$toast.info('Solo se puede subir archivos menores a 1 MB');
                const  input  = this.$refs.filecheckarranque;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.filecheckarranque;
                input.type = 'text'
                input.type = 'file';
                this.NombreArchivo='Elegir archivo (1MB)';
                return false;
            }

            this.Archivo=image.name;
		},
	},
	created() {
		this.poBtnSave.toast=0;
		this.bus.$off('NuevoCheckArranque');
        this.bus.$on('NuevoCheckArranque',(data,Id)=>{
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false;
            this.bus.$off('Save_checkarranque');
            this.bus.$on('Save_checkarranque',()=>{
                this.Guardar();
            });
            this.Limpiar();
            if(Id>0){
                this.CheckArranque.IdCheckArranque=Id;
                this.getOne();
                this.bus.$emit('Desbloqueo',false);
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
        });
        if (this.CheckArranque.IdCheckArranque!=0) {
            this.getOne();
        }
	},
	computed:{
		typeCalendar: function() {
			return "single";
		},
	}
}
</script>

<style>

</style>
